import React, { useState } from "react";

export default function LoanRequestForm({ onSuccess }) {
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/wallet/loan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({ amount, note }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to request loan");

      onSuccess && onSuccess();
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="rounded-2xl border border-black/5 dark:border-white/10 bg-white dark:bg-slate-900 shadow-sm p-5 max-w-xl">
      <Header title="Demande de prêt" subtitle="Soumettez une demande rapidement" />
      {err && <InlineError text={err} />}

      <form onSubmit={handleSubmit} className="mt-4 space-y-4">
        <Field label="Montant">
          <input type="number" min="1" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className={inputCls} required />
        </Field>

        <Field label="Note (optionnel)">
          <input value={note} onChange={(e) => setNote(e.target.value)} className={inputCls} placeholder="Ex: Besoin urgent" />
        </Field>

        <button disabled={loading} className={primaryBtn}>
          {loading ? "Envoi..." : "Soumettre"}
        </button>
      </form>
    </section>
  );
}

/* helpers */
function Header({ title, subtitle }) {
  return (
    <div>
      <h3 className="text-base font-semibold text-slate-900 dark:text-white">{title}</h3>
      <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>
    </div>
  );
}
function Field({ label, children }) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">{label}</label>
      {children}
    </div>
  );
}
function InlineError({ text }) {
  return (
    <div className="mt-4 rounded-2xl border border-red-500/20 bg-red-500/10 px-4 py-3 text-sm text-red-700 dark:text-red-300">
      {text}
    </div>
  );
}
const inputCls =
  "w-full rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-slate-950 px-4 py-3 text-slate-900 dark:text-white outline-none " +
  "focus:ring-2 focus:ring-slate-900/10 dark:focus:ring-white/10";
const primaryBtn =
  "w-full rounded-2xl bg-slate-900 text-white py-3 font-medium hover:opacity-95 transition disabled:opacity-60 dark:bg-white dark:text-slate-900";
